import React from 'react';
import { getLink } from '../links';
import { TFunction } from 'i18next';

export const domainContent = (t: TFunction) => (
  <>
    <p>{t('editorx.error.domain.content1')}</p>
    <ol>
      <li>
        <a href={getLink('mySites')}>{t('editorx.error.domain.list-item1')}</a>
      </li>
      <li>{t('editorx.error.domain.list-item2')}</li>
      <li>{t('editorx.error.domain.list-item3')}</li>
    </ol>
    <p>{t('editorx.error.domain.content2')}</p>
    <p
      dangerouslySetInnerHTML={{
        __html: t('editorx.error.domain.content3', {
          link: getLink('helpCenter'),
        }),
      }}
    />
  </>
);
